export function createQuery(host,type){
    if (type === 'snmp'){
        return `
        from(bucket: "telegraf")
            |> range(start: -30m)
            |> filter(fn: (r) => r["_measurement"] == "ezelink_license_value")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => r["instance"] == "connected" or r["instance"] == "utilization")
            |> last()
        `;
    }
    else{
        return `
        from(bucket: "telegraf")
            |> range(start: -30m)
            |> filter(fn: (r) => r["_measurement"] == "ezelink_license_value")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => r["instance"] == "connected" or r["instance"] == "utilization")
            |> last()
        `;
    }
}